import { splitProps, type Component, type JSX } from 'solid-js';
import { cn } from '~/shared/lib/cn';

export interface GlassCardProps extends JSX.HTMLAttributes<HTMLDivElement> {
  strong?: boolean;
  flat?: boolean;
  interactive?: boolean;
}

export const GlassCard: Component<GlassCardProps> = (props) => {
  const [local, rest] = splitProps(props, ['strong', 'flat', 'interactive', 'class', 'children']);
  const base = local.flat ? 'glass-flat' : local.strong ? 'glass-strong' : 'glass';
  return (
    <div
      {...rest}
      class={cn(base, local.interactive && 'lift cursor-pointer', local.class)}
    >
      {local.children}
    </div>
  );
};
